"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/* eslint-disable max-len */
var _default = exports["default"] = 'M12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18zm-.818-11.908v4.18c0 .653.366 1.183.818 1.183.452 0 .818-.53.818-1.184V9.092c0-.653-.366-1.183-.818-1.183-.452 0-.818.53-.818 1.183zm0 6.996v.006c0 .45.366.815.818.815a.817.817 0 0 0 .818-.815v-.006a.817.817 0 0 0-.818-.815.817.817 0 0 0-.818.815z';